export const ENUM_INVITATIONS_STATUS={
    PENDING:'PENDIENTE',
    CANCELLED:'CANCELADA',
    ACCEPTED:'ACEPTADA',
    EXPIRED:'EXPIRADA'
}